import React, { useEffect, useState } from "react";

import { Col, Container, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import Loading from "../../loading/pages/Loading";
import Failed from "../../loading/pages/Failed";
import CardPlan from "../components/CardPlan";
import { PALETTE } from "../../common/ThemeConstants";
import { getRequest } from "../../api/axiosRequests";
import { useAuth } from "../../auth/hook";
import NavLinkButton from "../../common/components/NavLinkButton";
import ContainerResponsive from "../../common/components/ContainerResponsive";
import WorkoutsHeader from "../components/WorkoutsHeader";
import { useWindowWidth } from "../../api/useWindowWidth";

export default function Workouts() {
  const location = useLocation();
  const categoryName = location.pathname.split("/").pop();
  const [_, isMobile] = useWindowWidth();
  const auth = useAuth();
  const user = auth.user;
  const userSubscription = auth.userSubscription;
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState({ id: -1, name: categoryName });
  const [isLoaded, setIsLoaded] = useState(false);
  const [isFailed, setIsFailed] = useState(false);
  const [plans, setPlans] = useState([]);
  const [filteredPlans, setFilteredPlans] = useState([]);

  const get_local_date = (date) => {
    const d = new Date(date).toLocaleString("it-IT", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
    return d;
  };

  const fetchData = () => {
    const headers = { Authorization: localStorage.getItem("jwt") };
    const promise1 =
      user.id == -1
        ? getRequest("planListForUser/", headers)
        : getRequest("planListForUser/" + user.id, headers);
    const promise2 = getRequest("planList/", headers);
    const promise3 = getRequest("userData/", headers);
    const promise4 = getRequest("categoryList/", headers);

    Promise.all([promise1, promise2, promise3, promise4])
      .then((values) => {
        let userPlanList = values[0]["data"];
        let planList = values[1]["data"];
        const role = values[2]["data"]["role"];
        const isAdmin = role === "Admin";
        const categories = values[3].data;
        const categoryData = categories.filter(
          (category) => category.name === categoryName
        )[0];
        setCategory(categoryData);
        setCategories(categories);

        if (!Array.isArray(userPlanList)) {
          userPlanList = [];
        }
        if (!Array.isArray(planList)) {
          planList = [];
        }

        // Filter the plans by category
        let categoryPlanList = planList.filter(
          (plan) => plan.category == categoryData.id
        );

        // Filter the plans by sex if the user is not an admin
        if (!isAdmin) {
          categoryPlanList = categoryPlanList.filter(
            (plan) => plan.sex.includes(user.sex)
          );
        }

        // Check if the user has already subscribed to the plan and set the isActive flag
        categoryPlanList.map((plan) => {
          const found = (element) => element["plan"]["id"] === plan.id;
          // Found active plan
          if (userPlanList.some(found)) {
            plan["isActive"] = true;
            plan["expire_at"] = get_local_date(
              userPlanList.find(found)["expire_at"]
            );
            plan["toLink"] = "/workout/" + plan.id + "/Content";
            // Found active user subscription
          } else if (userSubscription.id != -1) {
            plan["isActive"] = true;
            plan["expire_at"] = get_local_date(userSubscription.expire_at);
            plan["toLink"] = "/workout/" + plan.id + "/Content";
            // User is admin
          } else if (isAdmin) {
            plan["isActive"] = true;
            plan["expire_at"] = "per sempre";
            plan["toLink"] = "/workout/" + plan.id + "/Content";
          } else {
            plan["isActive"] = false;
            plan["toLink"] = "/workout/" + plan.id + "/Details";
          }
        });

        // Sort the plans so that the active plans are at the top
        categoryPlanList.sort((a, b) => b["isActive"] - a["isActive"]);

        // Show only the assigned ones if the category is Personal
        if (categoryName === "Personal") {
          categoryPlanList = categoryPlanList.filter((plan) => {
            const found = (element) => element["plan"]["id"] === plan.id;
            return plan.isActive === true && userPlanList.some(found);
          });
        }

        setIsFailed(false);
        setIsLoaded(true);
        setPlans(categoryPlanList);
        setFilteredPlans(categoryPlanList);
      })
      .catch((errs) => {
        console.log(errs);
        setIsFailed(true);
        setIsLoaded(true);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, [categoryName, user]);

  const onSearchChange = (name) => {
    const nameLowerCase = name.toLowerCase();
    const filtered = plans.filter((plan) =>
      plan.name.toLowerCase().includes(nameLowerCase)
    );
    setFilteredPlans(filtered);
  };

  const getCategoryName = (category) => {
    switch (category) {
      case "Workout":
        return "Fitness";
      case "Postural":
        return "Posturale";
      case "Personal":
        return "Personale";
      default:
        return "Generale";
    }
  }

  return (
    <div>
      <WorkoutsHeader onSearchChange={onSearchChange} />
      <ContainerResponsive>
        {!isLoaded && <Loading />}
        {isLoaded && isFailed && (
          <Failed
            separatorText={""}
            mainDescription={"Failed to load the workout list."}
          />
        )}
        {isLoaded && !isFailed && (
          <div>
            <Container className="my-1 text-center">
              <div style={{ width: "100%", display: "flex" }} className="m-auto">
                {categories.map((category) => (
                  <div key={category.id} className="pe-2" style={{ width: "fit-content" }}>
                    <NavLinkButton
                      text={category.name}
                      to={"/account/Workouts/" + category.name}
                      backgroundColor={PALETTE.LIGHTGRAY}
                      borderColor={PALETTE.LIGHTGRAY}
                      color={PALETTE.GRAY}
                      backgroundColorHover={PALETTE.GRADIENTLIGHT}
                      colorHover={PALETTE.SECONDARYCOLORHOVER}
                      px
                      shadow
                    />
                  </div>
                ))}
              </div>
            </Container>
            <Container className="mt-4 mb-3">
              <h3 className="text-start px-1" >
                Scegli il tuo allenamento
              </h3>
              <p className="text-start px-1 mb-0" style={{ color: PALETTE.GRAY }}>
                Scegli il piano di allenamento {getCategoryName(category.name).toLowerCase()} che preferisci e inizia subito a
                allenarti!
              </p>
            </Container>
            <Container className="mb-3">
              <Row className="m-auto p-0" style={{ width: "100%" }}>
                {filteredPlans.length > 0 &&
                  filteredPlans.map((plan, idx) => (
                    <Col
                      key={plan.id + 1}
                      className="text-center align-self-center p-0 mx-1 my-2"
                      style={{
                        minWidth: 340,
                        width: 340,
                        maxWidth: isMobile ? "100%" : 340,
                        height: 100,
                        marginLeft: 2,
                        marginRight: 2
                      }}
                    >
                      <CardPlan
                        height={100}
                        isActive={plan.isActive}
                        to={plan.toLink}
                        color={PALETTE.DARK}
                        backgroundColor={PALETTE.WHITE}
                        title={plan.name}
                        cover={plan.cover}
                        weeks={plan.weeks}
                        price={plan.price}
                        level={plan.level}
                        expire_at={plan.expire_at}
                        equipments={plan.equipments}
                      />
                    </Col>
                  ))}
                {plans.length === 0 && (
                  <div className="pt-5">
                    <Failed
                      separatorText={""}
                      mainDescription={`Al momento non c'è nessun allenamento ${getCategoryName(category.name).toLowerCase()} disponibile.`}
                      secondaryDescription={""}
                      paddingTop={"0px"}
                    />
                  </div>
                )}
              </Row>
            </Container>
          </div>
        )}
      </ContainerResponsive>
    </div>
  );
}
